import { Link } from 'react-router-dom';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Buttons } from '../../../enums/HeaderEnums';
import MenuBarUserProfile from '../../MenuBar/MenuBarUserProfile';
import { StyledLogoMobile } from '../../../styles/styled/Logo.styled';

const HeaderMobile = ({
  anchorElNav,
  isUserAuthenticated,
  handleEdit,
  handleOpenNavMenu,
  handleCloseNavMenu,
  loggedUser,
  logoutUser,
  showUpdateModal,
  setShowUpdateUserModal,
  showChangePasswordModal,
  setShowChangePasswordModal,
  showUpdateUserModal,
  user,
}) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'space-between',
        p: 1,
        m: 1,
        borderRadius: 1,
      }}
    >
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleOpenNavMenu}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={{
          display: { xs: 'block', md: 'none' },
        }}
      ></Menu>

      <StyledLogoMobile src={require('../../../assets/images/logo.png')} />

      {isUserAuthenticated ? (
        <MenuBarUserProfile
          logout={logoutUser}
          loggedUser={loggedUser}
          user={user}
          showChangePasswordModal={showChangePasswordModal}
          setShowChangePasswordModal={setShowChangePasswordModal}
          showUpdateUserModal={showUpdateUserModal}
          setShowUpdateUserModal={setShowUpdateUserModal}
          handleEdit={handleEdit}
          showUpdateModal={showUpdateModal}
        />
      ) : (
        <MenuItem key={'loginButton'}>
          <Link to="/login">{Buttons.signIn}</Link>
        </MenuItem>
      )}
    </Box>
  );
};

export default HeaderMobile;
